// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"aca2312d","188":"b6fab6b2","329":"df17103c","367":"9007f4f4","421":"2441f781","649":"7865bbf5","672":"b291083b","721":"5f56e61a","850":"544e9e1f","914":"4aab516c","950":"d08404b1"}[chunkId] + ".chunk.js";
};